@defer(when isLoaded) {
<mat-sidenav-container #librarysidenavContainer
  [@.disabled]="true"
  [hasBackdrop]="false"
  [style.transition]="'none !important'"
  [style.box-sizing]="'border-box'"
  >
  <mat-sidenav-content #librarycontent
    [@.disabled]="true"
    [style.max-width.px]="contentWidth"
    [style.min-width.px]="0"
    [style.margin-right,px]="0"
  >
    @switch (activeSlide.toString()) {
      @case ('0') { <pop-ui-library-explore [(state)]="state" [search]="search"></pop-ui-library-explore> }
      @case ('1') { <pop-ui-library-collections [(state)]="state" [search]="search"></pop-ui-library-collections> }
      @case ('2') { <pop-ui-library-subjects [(state)]="state" [search]="search"></pop-ui-library-subjects> }
      @case ('3') { <pop-ui-library-groups [(state)]="state" [search]="search"></pop-ui-library-groups> }
      @case ('5') { <pop-ui-library-lessons [(state)]="state" [search]="search"></pop-ui-library-lessons> }
      @case ('6') { <pop-ui-library-lessons [(state)]="state" [search]="search"></pop-ui-library-lessons> }
    }
  </mat-sidenav-content>
  <mat-sidenav #librarysidenav
    popUISidenavFix
    position="end"
    [mode]="'over'"
    [@.disabled]="true"
    [style.transition]="'none !important'"
    [style.z-index]='100'
    [style.overflow-x]="'hidden'"
    [style.right]="embedded || isWeb ? '-1.0rem' : '0'"
    [style.top]="embedded ? 0 : '5.75rem'"
    [fixedBottomGap]="0"
    [fixedInViewport]="true"
    [opened]="isSlideVisible(6)"
    (openedChange)="onSidenavOpenChange($event)"
  >
    <pop-ui-library-lesson [(state)]="state"></pop-ui-library-lesson>
  </mat-sidenav>
</mat-sidenav-container>
}
@placeholder { <nx-superprep-dot-flashing></nx-superprep-dot-flashing> }
